import { Icon20FolderSimpleOutline } from '@vkontakte/icons';
import { Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import sharedFoldersImage from 'img/family-content/empty-block-folders.png';
import sharedFoldersImageDark from 'img/family-content/empty-block-folders-dark.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import styles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

export const SharedFolders = (): ReactElement => {
    const onClick = (): void => {
        xray.send('empty_family-folder_create', { p: 'cloud' });
        toolbarActions.create('familyFolder', 'emptyState', undefined, '', true, true);
    };

    return (
        <div className={styles.card} onClick={onClick} data-qa-id="family-shared-folders">
            <div className={styles.icon}>
                <Icon20FolderSimpleOutline data-qa-id="family-shared-folders-icon" />
            </div>
            <Spacing size={24} style={{ pointerEvents: 'none' }} />
            <Title level="2" data-qa-id="family-shared-folders-title">
                Создайте семейную папку
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-shared-folders-content">Она будет общей для всех участников семейной подписки</Text>
            <img
                src={isDarkTheme ? sharedFoldersImageDark : sharedFoldersImage}
                alt="Общие папки"
                className={classNames(styles.image, styles.foldersImage)}
                data-qa-id="family-shared-folders-image"
            />
        </div>
    );
};
